import PropTypes from "prop-types";
import Select from "react-select";
import { SYMBOL_CHECK_MARK, SYMBOL_X } from "../../../constants/text-symbols";
import reactSelectTheme from "../../style/common/input-type/react-select-theme.skin";
import reactSelectSkin from "../../style/common/input-type/react-select.skin";

const SearchInputBoolean = ({ className, onChange, value, required }) => {
  let options = [
    {
      value: "",
      label: "",
    },
    {
      value: "0",
      label: SYMBOL_X,
    },
    {
      value: "1",
      label: SYMBOL_CHECK_MARK,
    },
  ];

  return (
    <Select
      className={className}
      onChange={(event) => {
        onChange({ target: { value: event.value } });
      }}
      styles={reactSelectSkin}
      theme={reactSelectTheme}
      value={options.filter((option) => option.value === value)}
      options={options}
      required={required}
      isSearchable={false}
    />
  );
};

SearchInputBoolean.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

export default SearchInputBoolean;
